import { ComponentRoute } from '@/classes'

const GstReporViewtRoutes = {
  GstReportView: new ComponentRoute('/gstreports', 'GstReportView')
}

export default GstReporViewtRoutes
